module.exports = __webpack_public_path__ + "img/item14.bc69ccf9.png";